import { DEFAULT_TELEMETRY_EVENT_SEND_RATE } from '../otelTelemetryProcessor';
/**
 * Default send condition used to send activity event when the count reaches the default send rate.
 *
 * @param props The Telemetry Event Properties to evaluate.
 * @returns If the event should be sent.
 */
export const defaultSendCondition = (props) => {
    return props.totalCount != undefined && props.totalCount >= DEFAULT_TELEMETRY_EVENT_SEND_RATE;
};
/**
 * Default send condition used to send activity event immediately
 *
 * @param _props The Telemetry Event Properties to evaluate. These are not checked.
 * @returns True, the event should be sent.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const alwaysSendCondition = (_props) => {
    return true;
};
//# sourceMappingURL=telemetryUtilities.js.map